module.exports = __webpack_public_path__ + "img/4.816af604.png";